import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  token,
  locale,
  alert,
  float,
  required,
  params,
  tokens,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name_contact_1: "",
      address_contact_1: "",
      phone_contact_1: "",
      fax_contact_1: "",
      email_contact_1: "",
      website_contact_1: "",

      map_contact:"",

      full_name: "",
      email: "",
      phone: "",
      company: "",
      title: "",
      message: "",
    };
  }
  componentDidMount = async () => {
    loading(false);

    this.Get();
  };
  Get = async () => {
    loading(true);
    let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
      let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
      result = await response.json();
      localStorage.setItem("scp-acc-tk", JSON.stringify(result));
    } else {
      result = tokens;
    }
    this.setState({
      name_contact_1:
        result?.setting[`${locale}_name_contact_1`] ||
        result?.setting?.th_name_contact_1,
      address_contact_1:
        result?.setting[`${locale}_address_contact_1`] ||
        result?.setting?.th_address_contact_1,
      phone_contact_1:
        result?.setting[`${locale}_phone_contact_1`] ||
        result?.setting?.th_phone_contact_1,
      fax_contact_1:
        result?.setting[`${locale}_fax_contact_1`] ||
        result?.setting?.th_fax_contact_1,
      email_contact_1:
        result?.setting[`${locale}_email_contact_1`] ||
        result?.setting?.th_email_contact_1,
      website_contact_1:
        result?.setting[`${locale}_website_contact_1`] ||
        result?.setting?.th_website_contact_1,
      map_contact: result?.setting?.map_contact,
    });
    loading(false);
  };
  Submit = async () => {
    const { product, full_name, email, phone,company,
title, message } = this.state;
    if (!full_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณาชื่อ-นามสกุล");
      return;
    }
    if (!phone) {
          alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรศัพท์");
          return;
        }
    if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    }
    if (!email.includes("@")) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }
    if (phone.length < 10) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ครบถ้วน");
      return;
    }
    if (!float(phone)) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ถูกต้อง");
      return;
    }
    loading(true);

    await fetch(
      process.env.REACT_APP_API_URL + `/contact/${new Date().getTime()}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: new Date().getTime(),
          product,
          full_name,
          email,
          phone,
          company,
title,
          message,
        }),
      }
    );
    loading(false);
    alert(
      "#",
      "success",
      "สำเร็จ",
      "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด"
    );
  };
  render() {
    const {
      name_contact_1,
      address_contact_1,
      phone_contact_1,
      fax_contact_1,
      email_contact_1,
      website_contact_1,
      full_name,
      email,
      phone,
      message,
      company,
title,
      map_contact
    } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />
        {/* SECTION 1 */}
        <div
          className="w-100 text-white position-relative"
          style={{
            minHeight: 350,
            backgroundImage: `url(${require("../assets/images/bg-1.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="text-center p-5 position-relative"
            style={{
              minHeight: 350,
            }}
          >
            <div className="w-100 d-flex justify-content-center mt-4">
              <div
                className="px-3 py-5 mt-4 rounded"
                style={{
                  backgroundColor: "rgba(0,0,0,0.3)",
                  maxWidth: 400,
                  minWidth: 300,
                  width: "70%",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)", // Safari
                }}
              >
                <h1 className="fw-bold mb-2">ติดต่อเรา</h1>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 position-relative pt-5">
          <div className="container">
            <div className="row mx-0 pb-5">
              <div className="col-12 col-lg-6 mb-3">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-12 mb-3 px-2">
                      <h3 className="fw-bold mb-3">{name_contact_1}</h3>
                      <div className="mb-4">เรายินดีให้คำปรึกษาเกี่ยวกับการจัดการขยะและการเลือกใช้เตาเผาขยะชุมชนที่เหมาะสมกับความต้องการของคุณ ทีมงานผู้เชี่ยวชาญพร้อมดูแล ให้ข้อมูลครบถ้วน ตั้งแต่การออกแบบ ติดตั้ง ไปจนถึงการบริการหลังการขาย</div>
                      {address_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf015"}</h5>
                          </div>
                          <div>
                            <b>{name_contact_1}</b>
                            <br />
                            <span>{address_contact_1}</span>
                          </div>
                        </div>
                      )}
                      {phone_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf095"}</h5>
                          </div>
                          <div>
                            <b>โทรได้ที่</b>
                            <br />
                            <span>{phone_contact_1?.split(",").map((phone, index) => <a href={`tel:${phone}`} key={index} style={{color: "inherit", textDecoration: "none"}}>{phone}{index !== phone_contact_1?.split(",").length - 1 ? ", " : ""}</a>)}</span>
                          </div>
                        </div>
                      )}
                      {fax_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf1ac"}</h5>
                          </div>
                          <div>
                            <b>โทรสาร</b>
                            <br />
                            <span>{fax_contact_1}</span>
                          </div>
                        </div>
                      )}
                      {email_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf0e0"}</h5>
                          </div>
                          <div>
                            <b>อีเมล</b>
                            <br />
                            <span><a href={`mailto:${email_contact_1}`} style={{color: "inherit", textDecoration: "none"}}>{email_contact_1}</a></span>
                          </div>
                        </div>
                      )}
                      {website_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf0ac"}</h5>
                          </div>
                          <div>
                            <b>เว็บไซต์</b>
                            <br />
                            <span><a href={website_contact_1} style={{color: "inherit", textDecoration: "none"}}>{website_contact_1}</a></span>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 py-5" id="input-message">
                <div className="card card-dashboard rounded-3 bg-secondary-light p-4 shadow-sm border-0">
                 <div className="row">
                                     <div className="col-6">
                                       <div className="mb-2">ชื่อ - นามสกุล</div>
                                       <input
                                         className="form-control mb-3"
                                         type="text"
                                         placeholder="ชื่อ - นามสกุล"
                                         onChange={(e) => {
                                           this.setState({ full_name: e.target.value });
                                         }}
                                         value={full_name}
                                       />
                                     </div>
                                     <div className="col-6">
                                       <div className="mb-2">เบอร์โทรศัพท์</div>
                                       <input
                                         className="form-control mb-3"
                                         type="text"
                                         placeholder="เบอร์โทรศัพท์"
                                         maxLength={10}
                                         onChange={(e) => {
                                           if (!float(e.target.value)) {
                                             return;
                                           }
                                           this.setState({ phone: e.target.value });
                                         }}
                                         value={phone}
                                       />
                                     </div>
                                     <div className="col-6">
                                       <div className="mb-2">อีเมล</div>
                                       <input
                                         className="form-control mb-3"
                                         type="email"
                                         placeholder="อีเมล"
                                         onChange={(e) => {
                                           this.setState({ email: e.target.value });
                                         }}
                                         value={email}
                                       />
                                     </div>
                                     <div className="col-6">
                                       <div className="mb-2">บริษัท</div>
                                       <input
                                         className="form-control mb-3"
                                         type="text"
                                         placeholder="บริษัท"
                                         onChange={(e) => {
                                           this.setState({ company: e.target.value });
                                         }}
                                         value={company}
                                       />
                                     </div>
                                     <div className="col-12">
                                       <div className="mb-2">หัวข้อที่สอบถาม</div>
                                       <input
                                         className="form-control mb-3"
                                         type="text"
                                         placeholder="หัวข้อที่สอบถาม"
                                         onChange={(e) => {
                                           this.setState({ title: e.target.value });
                                         }}
                                         value={title}
                                       />
                                     </div>
                                     <div className="col-12">
                                       <div className="mb-2">รายละเอียด</div>
                                       <textarea
                                         className="form-control mb-3"
                                         rows={8}
                                         placeholder="รายละเอียด"
                                         onChange={(e) => {
                                           this.setState({ message: e.target.value });
                                         }}
                                         value={message}
                                       />
                                     </div>
                                     <div className="col-12">
                                       <button
                                         className="btn btn-primary px-5 w-100"
                                         onClick={async () => {
                                           this.Submit();
                                         }}
                                       >
                                         ส่งข้อมูล
                                       </button>
                                     </div>
                                   </div>
                </div>
              </div>
            </div>                      
          </div>
          <iframe src={map_contact?.split("src=\"")[1]?.split("\"")[0]} width="100%" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
             
        </div>
        <Footer />
      </div>
    );
  }
}
